import PropTypes from 'prop-types'

const BOTGlobalGuidedNavigation = ({
  placeholders: {
    navigationContent = []
  } = {}
}) => navigationContent

BOTGlobalGuidedNavigation.propTypes = {
  placeholders: PropTypes.shape()
}

BOTGlobalGuidedNavigation.type = 'BOTGlobalGuidedNavigation'
BOTGlobalGuidedNavigation.placeholders = ['navigationContent']

export default BOTGlobalGuidedNavigation
